module.exports = __webpack_public_path__ + "img/tick.501120e0.svg";